class MinerwaCollection extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-filter-panel]');

    this.querySelectorAll('[data-facet-trigger]').forEach((trigger) => {
      const body = trigger.nextElementSibling;
      if (!body) return;
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        body.hidden = open;
      });
    });

    this.querySelector('[data-filters-open]')?.addEventListener('click', () => this.openFilters());
    this.querySelector('[data-filters-close]')?.addEventListener('click', () => this.closeFilters());

    this.querySelector('[data-sort]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      url.searchParams.delete('p');
      window.location.assign(url.toString());
    });

    this.onKeyDown = (event) => {
      if (event.key === 'Escape') this.closeFilters();
    };

    this.initPaging();
  }

  initPaging() {
    this.grid = this.querySelector('[data-grid]');
    this.pager = this.querySelector('[data-pagination]');
    if (!this.grid || !this.pager) return;

    this.cards = [...this.grid.querySelectorAll('.minerwa-card')];
    this.pageSize = Math.max(1, Number(this.grid.dataset.pageSize) || 24);
    this.pageCount = Math.ceil(this.cards.length / this.pageSize);

    if (this.pageCount <= 1) return;

    this.onPopState = () => this.showPage(this.pageFromUrl(), { push: false });
    window.addEventListener('popstate', this.onPopState);

    this.showPage(this.pageFromUrl(), { push: false, scroll: false });
  }

  pageFromUrl() {
    const value = Number(new URLSearchParams(window.location.search).get('p')) || 1;
    return Math.min(Math.max(1, value), this.pageCount);
  }

  showPage(page, { push = true, scroll = true } = {}) {
    this.page = page;
    const first = (page - 1) * this.pageSize;
    const last = first + this.pageSize;

    this.cards.forEach((card, i) => {
      card.hidden = i < first || i >= last;
    });

    this.renderPager();

    if (push) {
      const url = new URL(window.location.href);
      if (page > 1) url.searchParams.set('p', page);
      else url.searchParams.delete('p');
      window.history.pushState({}, '', url.toString());
    }

    if (scroll) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  pageNumbers() {
    const total = this.pageCount;
    const current = this.page;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [1];
    if (current > 3) pages.push('...');
    for (let p = Math.max(2, current - 1); p <= Math.min(total - 1, current + 1); p++) pages.push(p);
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  renderPager() {
    this.pager.hidden = false;
    this.pager.replaceChildren();

    const add = (label, page, modifier, disabled) => {
      const isGap = label === '...';
      const el = document.createElement(isGap || disabled ? 'span' : 'button');
      el.className = 'minerwa-plp__page' + (modifier ? ' minerwa-plp__page--' + modifier : '');
      el.textContent = label;
      if (!isGap && !disabled) {
        el.type = 'button';
        el.addEventListener('click', () => this.showPage(page));
      }
      if (page === this.page && !isGap) {
        el.classList.add('minerwa-plp__page--current');
        el.setAttribute('aria-current', 'page');
      }
      this.pager.appendChild(el);
    };

    add('‹', this.page - 1, 'arrow', this.page === 1);
    this.pageNumbers().forEach((n) => add(String(n), n, n === '...' ? 'gap' : null, n === '...'));
    add('›', this.page + 1, 'arrow', this.page === this.pageCount);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('popstate', this.onPopState);
    this.scrim?.remove();
  }

  openFilters() {
    if (!this.panel) return;
    this.panel.dataset.open = 'true';
    this.scrim = document.createElement('div');
    this.scrim.className = 'minerwa-plp__scrim';
    this.scrim.addEventListener('click', () => this.closeFilters());
    document.body.appendChild(this.scrim);
    document.addEventListener('keydown', this.onKeyDown);
  }

  closeFilters() {
    if (!this.panel) return;
    this.panel.dataset.open = 'false';
    this.scrim?.remove();
    this.scrim = null;
    document.removeEventListener('keydown', this.onKeyDown);
  }
}

if (!customElements.get('minerwa-collection')) {
  customElements.define('minerwa-collection', MinerwaCollection);
}
